module.exports = __webpack_public_path__ + "img/L08.8cc534a7.jpg";